<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 lg4>
        <v-form data-vv-scope="formLogin" v-model="formLogin.valid">
          <v-card class="elevation-1 pa-3">
            <v-card-text>
              <div class="layout column align-center">
                <img id="logo" src="@/assets/logo.svg" alt="Admin ooca" class="mb-5" />
              </div>
              <v-text-field
                :label="$t('login.username')"
                v-model="formLogin.username"
                v-validate="'required|emailTel'"
                :error-messages="errors.collect('formLogin.username')"
                data-vv-name="username"
                prepend-icon="person"
                type="text"
                data-vv-validate-on="input"
              />
              <v-text-field
                :label="$t('login.password')"
                v-model="formLogin.password"
                v-validate="'required'"
                :error-messages="errors.collect('formLogin.password')"
                data-vv-name="password"
                prepend-icon="lock"
                type="password"
                data-vv-validate-on="input"
              />
              <v-btn block :disabled="!formLogin.valid" color="primary" type="submit" @click.prevent="submit">
                {{ $t('login.loginBtn') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import loader from '../utils/loader'
import store from '../../store';
import auth from '../../services/auth';
import Layout from '../../layouts/SimpleLayout.vue';
import formMixin from '../../Mixins/form';
import Form from '../../form/form';
import userTransformer from '../../transformers/user';

export default {
  store,
  mixins: [formMixin],
  data: () => ({
    dictionary: {
      attributes: {
        username: 'E-mail Address or Phone number',
      },
      custom: {},
    },
    formLogin: new Form({
      data() {
        return {
          username: '',
          email: '',
          tel: '',
          password: '',
          valid: false,
        };
      },
      transformToPayload: userTransformer.login,
    }),
  }),
  methods: {
    submit() {
      this.$validator.validateAll('formLogin').then((result) => {
        if (result) {
          auth
            .newLogin(this.formLogin, store.state.route.query.redirect)
            .then((data) => {
              const user = data.user.data;
              this.$notify({
                title: 'Login success',
                text: `Hello ${user.email}`,
                type: 'success',
                // duration: -1000
              });
            })
            .catch(() => {
              //reset form
              this.$notify({
                title: 'Login Fail',
                text: 'Something wrong about your account',
                type: 'error',
                // duration: -1000
              });
            });
        }
      });
    },
  },
  components: {
    Layout,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#logo {
  width: 275px;
  height: 110px;
}
</style>
